import { GraphLink } from "./link.model";
import { GraphNode } from "./node.model";

export class Graph {
  nodes: GraphNode[] = [];
  links: GraphLink[] = [];
}
